import { useEffect, useState } from 'react';
import { useStore } from 'react-redux';

// types
import { FetchPressroomResult, PressroomRequestConfig } from '../types/press-portal.types';

// utils
import getEndpoint from 'utils/endpoints';
import { useCurrentLanguage } from 'utils/hooks/useCurrentLanguage';
import { fetchWithInterceptors } from 'utils/interceptors';

function useFetchPressroomInfo<T>({ locale }: PressroomRequestConfig): FetchPressroomResult<T> {
  const [loading, setLoading] = useState<boolean>(false);
  const [pressroom, setPressroom] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const lang = useCurrentLanguage();
  const state = useStore();

  useEffect(() => {
    const fetchMaterial = async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams({
          pressroom: locale,
          lang,
          locale,
        });
        const response = await fetchWithInterceptors(
          `${getEndpoint('newsDesk', state)}/pressroom_info?${params.toString()}`,
        );
        if (!response.ok) {
          throw new Error(`api error: ${response.status} ${response.statusText}`);
        }
        const data: { pressroom: T } = await response.json();
        setError(null);
        setPressroom(data.pressroom);
      } catch (err: unknown) {
        const error = err as Error;
        setError(`internal error: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchMaterial();
  }, [locale]);

  return { loading, error, pressroom };
}

export { useFetchPressroomInfo };
